import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "./App.css";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const DEFAULT_T = {
  nav: { services: "Hizmetlerimiz", about: "Hakkımızda", contact: "Randevu", gallery: "Galeri" },
  hero: {
    headline: "Güzelliğini\nYeniden Yaz",
    sub: "Aphea; cilt, beden ve yaşam enerjisini bütünsel bir yaklaşımla ele alan bir güzellik & dönüşüm merkezidir.\nBurada dönüşüm yalnızca görünümde değil, hissettiklerinde başlar.",
    mini: "Güzel Yaş Alma  •  Cilt Bakımı  •  Bölgesel İncelme  •  Terapiler",
    cta: "Randevu Al",
    waCta: "Ücretsiz Danışmanlık",
    location: "Antalya – Döşemealtı | Palm City Modern",
  },
  problem: {
    label: "Sizi Tanıyoruz",
    headline: "Kendini iyi hissetmiyor ama nereden başlayacağını bilmiyor musun?",
    body: "Cilt problemleri, yorgunluk, kilo, stres…\nBunların hiçbiri tek başına çözülmez.\nÇünkü beden bir bütündür.",
    cta: "Çözümü Keşfet",
  },
  philosophy: {
    label: "Marka Hikayesi",
    q1: "Aphea'da dönüşüm yüzeyde kalmaz.",
    q2: "Bedenle başlar, ruhla tamamlanır.",
    body1: "Güzellik yalnızca görünen değildir. Güzellik; hissedilen, taşınan ve yaşanan bir hâldir.",
    body2: "Aphea adını, Antik Yunan'da güzellik ve gençliğin sembolü olan Aphrodite'in kökünden alır. Bu köken, Aphea'nın duruşunu tanımlar.",
    body3: "Aphea'da dönüşüm yüzeyde kalmaz. Bedenle başlar, ruhla tamamlanır. Her uygulama; dengeyi yeniden kurmak, hafiflemek ve kişinin kendi güzelliğiyle yeniden temas etmesi için tasarlanır.",
    brand: "APHEA; güzelliği yeniden tanımlayan; bütünsel bir güzellik & dönüşüm merkezidir.",
  },
  services: {
    label: "Hizmetlerimiz",
    headline: "Güzelliğe Bütünsel Bir Yaklaşım",
    sub: "Her hizmetimiz, size özel tasarlanmış kişisel bir deneyim sunar.",
    items: [
      { title: "Güzel Yaş Alma", desc: "Güzel yaş almak, zamanla savaşmak değil; onunla birlikte parlamaktır. Aphea, doğallığınızı koruyarak en iyi hâlinize ulaşmanız için yanınızda." },
      { title: "Bölgesel İncelme", desc: "Metabolizmanızı ve bedeninizi bir bütün olarak ele alan, bilimsel temelli kişisel programlar." },
      { title: "Cilt Analizi & Bakım Ritüelleri", desc: "İleri teknoloji analizle cildinizin gerçek ihtiyaçlarını belirler, size özel ritüeller tasarlarız." },
      { title: "Lazer Uygulamaları & Saç Derisi Terapileri", desc: "Güncel lazer teknolojisiyle güvenli, etkili ve kalıcı sonuçlar sunan profesyonel uygulamalar." },
      { title: "Medikal Manikür & Pedikür", desc: "Estetik ve sağlığı bir arada sunan medikal uygulamalarla el ve ayak bakımında profesyonel deneyim." },
      { title: "Masaj & Beden Terapileri", desc: "Bölgesel hedefli masaj teknikleriyle fiziksel rahatlama ve ruhsal yenilenme sağlayan terapiler." },
    ],
  },
  experience: {
    label: "Nasıl Çalışırız",
    headline: "Bu bir bakım değil, bir deneyim.",
    steps: [
      { num: "01", title: "Analiz", desc: "Bedeninizin ve cildinizin gerçek ihtiyaçları belirlenir. Hiçbir şey varsayımla başlamaz." },
      { num: "02", title: "Kişisel Plan", desc: "Size özel tasarlanmış bir dönüşüm planı hazırlanır. Standart protokol yoktur." },
      { num: "03", title: "Dönüşüm", desc: "Uygulama sürecinde sürekli takip ve iyileştirmeyle gerçek sonuçlara ulaşılır." },
    ],
  },
  about: {
    label: "Hakkımızda",
    headline: "Dönüşümün Yeni Evi",
    badge: "Çok Yakında",
    desc: "Antalya Döşemealtı, Palm City Modern'de hayata geçirdiğimiz güzellik ve dönüşüm merkezimiz yakında kapılarını açıyor. Modern tasarımı, uzman ekibi ve kişiye özel yaklaşımıyla Aphea; güzellik anlayışını yeniden tanımlıyor. Bu özel yolculukta sizi ağırlamaktan büyük mutluluk duyacağız.",
    location: "Antalya – Döşemealtı | Palm City Modern",
  },
  cta: {
    headline: "Kendi en iyi hâlinle\nyeniden buluşmaya hazır mısın?",
    sub: "Gelin tanışalım. Sizin için tasarlanmış dönüşüm yolculuğunu birlikte başlatalım.",
    btn: "Randevu Al",
    waCta: "WhatsApp'tan Yaz",
  },
  contact: {
    label: "Randevu",
    headline: "Gelin Tanışalım",
    sub: "Kendi en iyi hâlinize ulaşmak için ilk adımı atın. Size özel dönüşüm yolculuğunuzu planlamak için bizimle iletişime geçin.",
    nameLabel: "Ad Soyad",
    phoneLabel: "Telefon Numarası",
    serviceLabel: "İlgilendiğiniz Hizmet",
    msgLabel: "Mesajınız (İsteğe Bağlı)",
    submit: "Randevu Talep Et",
    waCta: "WhatsApp ile Randevu Al",
    waNote: "Anında randevu almak veya sorularınız için WhatsApp üzerinden bize ulaşabilirsiniz.",
    igNote: "Son çalışmalarımızı görmek ve güncellemeler için bizi takip edin.",
    success: "Talebiniz başarıyla iletildi. En kısa sürede sizinle iletişime geçeceğiz.",
    error: "Bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.",
    services: ["Güzel Yaş Alma", "Bölgesel İncelme", "Cilt Analizi & Bakım Ritüelleri", "Lazer Uygulamaları & Saç Derisi Terapileri", "Medikal Manikür & Pedikür", "Masaj & Beden Terapileri"],
  },
  footer: { tagline: "Güzelliği bütünsel bir yaklaşımla sunuyoruz.", rights: "Tüm hakları saklıdır." },
};

const DEFAULT_IMAGES = {
  heroBg: "https://customer-assets.emergentagent.com/job_transform-beauty-4/artifacts/sedr0xrt_c2.png",
  moodBoard: "https://customer-assets.emergentagent.com/job_transform-beauty-4/artifacts/q8j9514d_Screenshot%202026-03-23%20at%2013.50.03.png",
  brandStory: "https://customer-assets.emergentagent.com/job_e8756ca2-7c8b-4cf8-a686-f20069ea76c3/artifacts/vrkgsd4o_Post%20-%207.jpg",
  venue: "https://customer-assets.emergentagent.com/job_transform-beauty-4/artifacts/z65m8smc_Post-8.jpg",
  logoWhite: "https://customer-assets.emergentagent.com/job_transform-beauty-4/artifacts/f37nt8q4_Aphea%20Logo%20W%20%281%29.png",
  logoNavbar: "https://customer-assets.emergentagent.com/job_transform-beauty-4/artifacts/lrzqgvxo_BRANDMARK%20LOGO%20BEYAZ.svg",
  logoFooter: "https://customer-assets.emergentagent.com/job_transform-beauty-4/artifacts/z9s3xb3p_APHEA%20BRANDMARK%20WHITE.png",
};

const DEFAULT_SETTINGS = {
  headingFont: "Cormorant Garamond",
  bodyFont: "Nunito",
  primaryColor: "#6B0F2A",
  accentColor: "#D7D2CB",
  backgroundColor: "#F5F0E8",
  whatsappNumber: "905336333807",
  instagramHandle: "aphealife",
  phoneNumber: "+90 533 633 38 07",
  siteTitle: "APHEA Dönüşüm & Güzellik Merkezi",
  mapsUrl: "https://www.google.com/maps/search/Palm+City+Modern+D%C3%B6%C5%9Femealt%C4%B1+Antalya",
};

const SERVICE_IMAGES = [
  "https://customer-assets.emergentagent.com/job_transform-beauty-4/artifacts/hjaz6fqr_6-gu%CC%88zel%20yas%CC%A7%20alma2.png",
  "https://static.prod-images.emergentagent.com/jobs/e8756ca2-7c8b-4cf8-a686-f20069ea76c3/images/7aa6679eb4e27cdd0fa7fecbf8bd1767f98e05e1a90aa90c0739a0cf30019f31.png",
  "https://static.prod-images.emergentagent.com/jobs/e8756ca2-7c8b-4cf8-a686-f20069ea76c3/images/2b8e001536275d7cdc121e623ca10fea56aec793e6964573acf5b9fb4272a8af.png",
  "https://static.prod-images.emergentagent.com/jobs/e8756ca2-7c8b-4cf8-a686-f20069ea76c3/images/82b264e5fd70731ae111085e6719ccbb9e5560114559286733aefb4ab38ea4ed.png",
  "https://static.prod-images.emergentagent.com/jobs/e8756ca2-7c8b-4cf8-a686-f20069ea76c3/images/ae29cbcb1b631d0fb02926b75c0028358a61ea764c77110211f7a91d72410261.png",
  "https://static.prod-images.emergentagent.com/jobs/e8756ca2-7c8b-4cf8-a686-f20069ea76c3/images/887d59dff9ec4c7aff2be4eb52ce5c02414f50a1cecda62e7305104d8cdf46ae.png",
];

function WhatsAppIcon({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
    </svg>
  );
}

function InstagramIcon({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
    </svg>
  );
}

function FacebookIcon({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
    </svg>
  );
}
function YouTubeIcon({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
    </svg>
  );
}

function LinkedInIcon({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 0 1-2.063-2.065 2.064 2.064 0 1 1 2.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
    </svg>
  );
}

function MapPinIcon() {
  return (
    <svg width={14} height={14} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" style={{ display: "inline", marginRight: 5 }}>
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  );
}

export default function Landing() {
  const [t, setT] = useState(DEFAULT_T);
  const [images, setImages] = useState(DEFAULT_IMAGES);
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [form, setForm] = useState({ name: "", phone: "", service: "", message: "" });
  const [formStatus, setFormStatus] = useState(null);
  const [skinExpanded, setSkinExpanded] = useState(false);

  // Fetch site content from API
  useEffect(() => {
    fetch(`${BACKEND_URL}/api/content`)
      .then(r => r.ok ? r.json() : null)
      .then(d => {
        if (!d) return;
        setT(prev => ({
          nav: { ...prev.nav, ...(d.nav || {}) },
          hero: { ...prev.hero, ...(d.hero || {}) },
          problem: { ...prev.problem, ...(d.problem || {}) },
          philosophy: { ...prev.philosophy, ...(d.philosophy || {}) },
          services: {
            ...prev.services, ...(d.services || {}),
            items: d.services?.items || prev.services.items,
          },
          experience: {
            ...prev.experience, ...(d.experience || {}),
            steps: d.experience?.steps || prev.experience.steps,
          },
          about: { ...prev.about, ...(d.about || {}) },
          cta: { ...prev.cta, ...(d.cta || {}) },
          contact: {
            ...prev.contact, ...(d.contact || {}),
            services: d.contact?.services || prev.contact.services,
          },
          footer: { ...prev.footer, ...(d.footer || {}) },
        }));
        if (d.images) setImages(prev => ({ ...prev, ...d.images }));
        if (d.settings) setSettings(prev => ({ ...prev, ...d.settings }));
      })
      .catch(() => {});
  }, []);

  // Dynamic fonts
  useEffect(() => {
    const heading = settings.headingFont || "Cormorant Garamond";
    const body = settings.bodyFont || "Nunito";
    let link = document.getElementById("custom-fonts");
    if (!link) {
      link = document.createElement("link");
      link.id = "custom-fonts";
      link.rel = "stylesheet";
      document.head.appendChild(link);
    }
    link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(heading)}:ital,wght@0,300;0,400;0,500;0,600;0,700;1,300;1,400&family=${encodeURIComponent(body)}:wght@300;400;500;600&display=swap`;
    let style = document.getElementById("font-override");
    if (!style) { style = document.createElement("style"); style.id = "font-override"; document.head.appendChild(style); }
    style.textContent = `.aphea-root{font-family:'${body}',sans-serif!important}.hero-headline,.section-headline,.about-headline,.philosophy-q1,.philosophy-q2,.philosophy-brand-stmt,.service-title,.mood-q1,.mood-q2,.contact-card-title{font-family:'${heading}',serif!important}`;
  }, [settings.headingFont, settings.bodyFont]);

  // Dynamic colors
  useEffect(() => {
    const p = settings.primaryColor || "#6B0F2A";
    const a = settings.accentColor || "#C9A96E";
    const bg = settings.backgroundColor || "#F5F0E8";
    let style = document.getElementById("color-override");
    if (!style) { style = document.createElement("style"); style.id = "color-override"; document.head.appendChild(style); }
    style.textContent = `.btn-primary,.about-badge{background:${a}!important;color:${p}!important}.section-label,.hero-eyebrow,.footer-subtitle{color:${p}!important}.service-title,.about-location a,.philosophy-q1,.philosophy-brand-stmt{color:${p}!important}.gold-line,.service-divider,.mood-divider{background:${p}!important}.aphea-root{background:${bg}!important}`;
  }, [settings.primaryColor, settings.accentColor, settings.backgroundColor]);

  // Dynamic title
  useEffect(() => {
    if (settings.siteTitle) document.title = settings.siteTitle;
  }, [settings.siteTitle]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormStatus("loading");
    try {
      await axios.post(`${BACKEND_URL}/api/contact`, { ...form, lang: "TR" });
      setFormStatus("success");
      setForm({ name: "", phone: "", service: "", message: "" });
    } catch (err) {
      if (err.response?.status === 429) {
        setFormStatus("error");
        setTimeout(() => setFormStatus(null), 6000);
        return;
      }
      // 1 kez otomatik tekrar dene
      try {
        await new Promise(r => setTimeout(r, 1500));
        await axios.post(`${BACKEND_URL}/api/contact`, { ...form, lang: "TR" });
        setFormStatus("success");
        setForm({ name: "", phone: "", service: "", message: "" });
      } catch {
        setFormStatus("error");
      }
    }
    setTimeout(() => setFormStatus(null), 6000);
  };

  const WA_URL = `https://wa.me/${settings.whatsappNumber || "905336333807"}`;
  const IG_URL = `https://www.instagram.com/${settings.instagramHandle || "aphealife"}/`;
  const FB_URL = "https://www.facebook.com/profile.php?id=61588045532272";
  const YT_URL = "https://www.youtube.com/@aphealife";
  const LI_URL = "https://www.linkedin.com/company/aphea-g%C3%BCzelllik-ve-d%C3%B6n%C3%BC%C5%9F%C3%BCm-merkezi/";
  const MAPS_URL = settings.mapsUrl || "https://www.google.com/maps/search/Palm+City+Modern+Antalya";

  return (
    <div className="aphea-root">
      {/* Floating WhatsApp */}
      <a href={WA_URL} target="_blank" rel="noopener noreferrer" className="wa-float" data-testid="whatsapp-float-btn" aria-label="WhatsApp">
        <WhatsAppIcon size={26} />
      </a>

      {/* NAVBAR */}
      <nav className={`aphea-nav${scrolled ? " scrolled" : ""}`} data-testid="navbar">
        <div className="nav-container">
          <button className="nav-logo-btn" onClick={() => scrollTo("hero")} data-testid="nav-logo">
            <img src={images.logoNavbar} alt="APHEA" className="nav-logo-img" />
          </button>
          <div className="nav-links" data-testid="nav-links">
            <button onClick={() => scrollTo("services")} data-testid="nav-services">{t.nav.services}</button>
            <button onClick={() => scrollTo("about")} data-testid="nav-about">{t.nav.about}</button>
            <Link to="/galeri" className="nav-gallery-link" data-testid="nav-gallery">{t.nav.gallery}</Link>
            <button onClick={() => scrollTo("contact")} data-testid="nav-contact">{t.nav.contact}</button>
          </div>
          <div className="nav-right">
            <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)} data-testid="menu-toggle" aria-label="Menu">
              {menuOpen
                ? <svg width={22} height={22} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                : <svg width={22} height={22} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
              }
            </button>
          </div>
        </div>
        {menuOpen && (
          <div className="mobile-menu" data-testid="mobile-menu">
            <button onClick={() => scrollTo("services")}>{t.nav.services}</button>
            <button onClick={() => scrollTo("about")}>{t.nav.about}</button>
            <Link to="/galeri" className="nav-gallery-link" onClick={() => setMenuOpen(false)}>{t.nav.gallery}</Link>
            <button onClick={() => scrollTo("contact")}>{t.nav.contact}</button>
          </div>
        )}
      </nav>

      {/* HERO */}
      <section id="hero" className="hero-section" data-testid="hero-section">
        <div className="hero-bg">
          <img src={images.heroBg} alt="APHEA" className="hero-img" />
          <div className="hero-overlay" />
        </div>
        <div className="hero-content" data-testid="hero-content">
          <h1 className="hero-headline" data-testid="hero-headline">
            {(t.hero.headline || "").split("\n").map((line, i) => <span key={i}>{line}<br /></span>)}
          </h1>
          <p className="hero-sub" data-testid="hero-sub">{t.hero.sub}</p>
          {t.hero.mini && <p className="hero-mini">{t.hero.mini}</p>}
          <div className="hero-actions">
            <button className="btn-primary" onClick={() => scrollTo("contact")} data-testid="hero-cta-btn">{t.hero.cta}</button>
            <a href={WA_URL} target="_blank" rel="noopener noreferrer" className="btn-outline-white" data-testid="hero-whatsapp-btn">
              <WhatsAppIcon size={16} /><span>{t.hero.waCta}</span>
            </a>
          </div>
          <p className="hero-location" data-testid="hero-location">
            <a href={MAPS_URL} target="_blank" rel="noopener noreferrer" className="location-link">
              <MapPinIcon />{t.hero.location}
            </a>
          </p>
        </div>
      </section>

      {/* PROBLEM */}
      <section className="problem-section" data-testid="problem-section">
        <div className="problem-inner">
          <p className="section-label">{t.problem.label}</p>
          <h2 className="problem-headline" data-testid="problem-headline">{t.problem.headline}</h2>
          <div className="problem-divider" />
          <p className="problem-body">
            {(t.problem.body || "").split("\n").map((line, i) => <span key={i}>{line}<br /></span>)}
          </p>
          <button className="btn-outline-gold" onClick={() => scrollTo("services")} data-testid="problem-cta">{t.problem.cta}</button>
        </div>
      </section>

      {/* PHILOSOPHY */}
      <section className="philosophy-section" data-testid="philosophy-section">
        <div className="philosophy-inner">
          <div className="philosophy-img-col">
            <div className="philosophy-img-wrap">
              <img src={images.brandStory} alt="Aphea Marka Hikayesi" className="philosophy-img" />
            </div>
          </div>
          <div className="philosophy-text-col">
            <p className="section-label">{t.philosophy.label}</p>
            <p className="philosophy-approach-title">APHEA YAKLAŞIMI</p>
            <blockquote className="philosophy-q1" data-testid="philosophy-q1">{t.philosophy.q1}</blockquote>
            <div className="gold-line" />
            <blockquote className="philosophy-q2" data-testid="philosophy-q2">{t.philosophy.q2}</blockquote>
            <p className="philosophy-body">{t.philosophy.body1}</p>
            <p className="philosophy-body" style={{ marginTop: 16 }}>{t.philosophy.body2}</p>
            <p className="philosophy-body" style={{ marginTop: 16 }}>{t.philosophy.body3}</p>
            <div className="philosophy-brand-stmt" data-testid="philosophy-brand">{t.philosophy.brand}</div>
          </div>
        </div>
      </section>

      {/* SERVICES */}
      <section id="services" className="services-section" data-testid="services-section">
        <div className="section-container">
          <p className="section-label centered">{t.services.label}</p>
          <h2 className="section-headline centered" data-testid="services-headline">{t.services.headline}</h2>
          <p className="section-sub centered" data-testid="services-sub">{t.services.sub}</p>
        </div>
        <div className="services-photo-grid">
          {(t.services.items || []).map((item, i) => (
            <div key={i} className="service-photo-card" data-testid={`service-card-${i}`}>
              <div className="service-photo-img-wrap">
                <img src={SERVICE_IMAGES[i] || SERVICE_IMAGES[0]} alt={item.title} className="service-photo-img" />
              </div>
              <div className="service-photo-info">
                <h3 className="service-photo-name">{item.title}</h3>
                <p className="service-photo-desc">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* MOOD STRIP - Brand Visual (no text overlay) */}
      <div className="mood-strip mood-brand-only" data-testid="mood-strip">
        <img src={images.moodBoard} alt="Aphea" className="mood-img" />
      </div>

      {/* YAPAY ZEKA DESTEKLİ CİLT ANALİZİ */}
      <section className="skin-analysis-section" data-testid="skin-analysis-section">
        <div className="skin-analysis-inner">
          <div className="skin-analysis-img-col">
            <img
              src="https://static.prod-images.emergentagent.com/jobs/e8756ca2-7c8b-4cf8-a686-f20069ea76c3/images/c677b529d5386982a0739960a421b1fc47f78f5d3224c6809a9da4cb99de1e28.png"
              alt="Cilt Analizi"
              className="skin-analysis-img"
            />
          </div>
          <div className="skin-analysis-text-col">
            <p className="section-label">Teknoloji & Güzellik</p>
            <h2 className="skin-analysis-headline">Yapay Zeka<br />Destekli Cilt<br />Analizi</h2>
            <div className="skin-analysis-divider" />
            <p className="skin-analysis-body">
              Cildinizin ihtiyaçlarını keşfetmek ve gerçek potansiyelini ortaya çıkarmak artık çok kolay.
            </p>
            <p className="skin-analysis-body" style={{ marginTop: 14 }}>
              Aphea'nın <strong>Yapay Zeka destekli Cilt Analizi</strong> ile cildinizin derinliklerindeki nem dengesi, gözenek yapısı, leke eğilimi ve sıkılık seviyesi hassas biçimde ölçümlenir. Size özel tasarlanmış bakım protokolü ve uzman tavsiyeleriyle dönüşümünüz başlar.
            </p>

            {/* DEVAMINI OKU */}
            <button
              className="skin-read-more-btn"
              onClick={() => setSkinExpanded(v => !v)}
              data-testid="skin-read-more"
            >
              {skinExpanded ? "Daha Az Göster ↑" : "Devamını Oku ↓"}
            </button>

            {skinExpanded && (
              <div className="skin-expanded-content" data-testid="skin-expanded">
                <p className="skin-expanded-title">Analizde Neler İncelenir?</p>
                <ul className="skin-expanded-list">
                  <li><strong>Cilt Tipi Belirleme</strong> — Yağlı, kuru, karma veya normal cilt yapınızın doğru tespiti ile size en uygun bakım protokolü belirlenir.</li>
                  <li><strong>Nem ve Hidrasyon Seviyesi</strong> — Cildinizin su tutma kapasitesi ve nem dengesi ölçülerek kuruluk eğilimi tespit edilir.</li>
                  <li><strong>Sebum Dengesi</strong> — Yağ üretimi, özellikle T bölgesindeki parlama ve sebum seviyesi hassas biçimde analiz edilir.</li>
                  <li><strong>Gözenek Durumu</strong> — Gözeneklerin büyüklüğü, tıkanıklığı ve genişliği değerlendirilerek temizlik ihtiyacı belirlenir.</li>
                  <li><strong>Hassasiyet ve Kızarıklık</strong> — Cilt bariyerinin direnci, rozasea eğilimi ve tahrişe yatkınlık ölçümlenir.</li>
                  <li><strong>Leke ve Pigmentasyon</strong> — Güneş lekeleri, yaşlılık lekeleri veya akne sonrası oluşan pigmentasyonlar haritalanır.</li>
                  <li><strong>Kırışıklık ve İnce Çizgiler</strong> — Cildin yaşlanma belirtileri, elastikiyet kaybı ve çizgilerin derinliği analiz edilir.</li>
                  <li><strong>Akne ve Siyah Nokta Eğilimi</strong> — Aktif sivilce, komedon ve bakteri yoğunluğu tespit edilerek tedavi planı oluşturulur.</li>
                  <li><strong>UV Hasarı</strong> — Çıplak gözle görülemeyen derin güneş lekeleri ve UV kaynaklı cilt hasarı görünür hâle getirilir.</li>
                </ul>
              </div>
            )}

            <button
              className="btn-primary skin-analysis-cta"
              onClick={() => scrollTo("contact")}
              data-testid="skin-analysis-cta"
            >
              Ücretsiz Analiz Randevusu
            </button>
          </div>
          <div className="skin-analysis-img-col skin-analysis-img-col-right">
            <img
              src="https://static.prod-images.emergentagent.com/jobs/e8756ca2-7c8b-4cf8-a686-f20069ea76c3/images/3a0bba19faa8b9c25d6f0c36c1300d67a2ac280c4ee56edacae171effa27088e.png"
              alt="Yapay Zeka Cilt Analizi"
              className="skin-analysis-img skin-analysis-img-right"
            />
            <div className="skin-analysis-labels">
              <span className="skin-label">PARLALIK</span>
              <span className="skin-label">GÖZ ALTI TORBALARI</span>
              <span className="skin-label">CİLT TONU EŞİTSİZLİĞİ</span>
              <span className="skin-label">SIKILIK</span>
            </div>
          </div>
        </div>
      </section>
      <section className="partners-section" data-testid="partners-section">
        <div className="partners-header">
          <p className="section-label centered partners-label">Profesyonel Partnerlerimiz</p>
        </div>
        <div className="partners-track-wrapper">
          <div className="partners-track">
            <img src="/logos/new-partner-1.png" alt="Partner" className="partner-logo" />
            <img src="/logos/new-partner-2.png" alt="Partner" className="partner-logo" />
            <img src="/logos/new-partner-3.png" alt="Partner" className="partner-logo" />
            <img src="/logos/new-partner-4.png" alt="Partner" className="partner-logo" />
            <img src="/logos/new-partner-1.png" alt="Partner" className="partner-logo" />
            <img src="/logos/new-partner-2.png" alt="Partner" className="partner-logo" />
            <img src="/logos/new-partner-3.png" alt="Partner" className="partner-logo" />
            <img src="/logos/new-partner-4.png" alt="Partner" className="partner-logo" />
          </div>
        </div>
      </section>

      {/* ABOUT */}
      <section id="about" className="about-section" data-testid="about-section">
        <div className="about-inner">
          <div className="about-img-col">
            <div className="about-img-wrap">
              <img src={images.venue} alt="Aphea Venue" className="about-img" />
              <div className="about-badge" data-testid="about-badge">{t.about.badge}</div>
            </div>
          </div>
          <div className="about-text-col">
            <p className="section-label">{t.about.label}</p>
            <h2 className="about-headline" data-testid="about-headline">{t.about.headline}</h2>
            <p className="about-desc" data-testid="about-desc">{t.about.desc}</p>
            <a href={MAPS_URL} target="_blank" rel="noopener noreferrer" className="about-location location-link" data-testid="about-location">
              <MapPinIcon />{t.about.location}
            </a>
          </div>
        </div>
      </section>

      {/* CTA REPEAT */}
      <section className="cta-repeat-section" data-testid="cta-repeat-section">
        <div className="cta-repeat-inner">
          <h2 className="cta-repeat-headline">
            {(t.cta.headline || "").split("\n").map((line, i) => <span key={i}>{line}<br /></span>)}
          </h2>
          <p className="cta-repeat-sub">{t.cta.sub}</p>
          <div className="cta-repeat-actions">
            <button className="btn-primary btn-lg" onClick={() => scrollTo("contact")} data-testid="cta-repeat-btn">{t.cta.btn}</button>
            <a href={WA_URL} target="_blank" rel="noopener noreferrer" className="btn-outline-white btn-lg" data-testid="cta-repeat-wa">
              <WhatsAppIcon size={18} /><span>{t.cta.waCta}</span>
            </a>
          </div>
        </div>
      </section>

      {/* CONTACT */}
      <section id="contact" className="contact-section" data-testid="contact-section">
        <div className="section-container">
          <p className="section-label centered contact-label">{t.contact.label}</p>
          <h2 className="section-headline centered" data-testid="contact-headline">{t.contact.headline}</h2>
          <p className="section-sub centered" data-testid="contact-sub">{t.contact.sub}</p>
          <div className="contact-grid">
            <form className="contact-form" onSubmit={handleSubmit} data-testid="contact-form">
              <div className="form-row-2">
                <div className="form-group">
                  <label className="form-label">{t.contact.nameLabel}</label>
                  <input type="text" className="form-input" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} required data-testid="form-name-input" />
                </div>
                <div className="form-group">
                  <label className="form-label">{t.contact.phoneLabel}</label>
                  <input type="tel" className="form-input" value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} required data-testid="form-phone-input" />
                </div>
              </div>
              <div className="form-group">
                <label className="form-label">{t.contact.serviceLabel}</label>
                <select className="form-input" value={form.service} onChange={e => setForm({ ...form, service: e.target.value })} data-testid="form-service-select">
                  <option value="">—</option>
                  {(t.contact.services || []).map((s, i) => <option key={i} value={s}>{s}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label className="form-label">{t.contact.msgLabel}</label>
                <textarea className="form-input form-textarea" rows={4} value={form.message} onChange={e => setForm({ ...form, message: e.target.value })} data-testid="form-message-input" />
              </div>
              {formStatus === "success" && <p className="form-success" data-testid="form-success">{t.contact.success}</p>}
              {formStatus === "error" && <p className="form-error" data-testid="form-error">{t.contact.error}</p>}
              <button type="submit" className="btn-primary btn-block" disabled={formStatus === "loading"} data-testid="form-submit-btn">
                {formStatus === "loading" ? "..." : t.contact.submit}
              </button>
            </form>
            <div className="contact-sidebar">
              <div className="contact-card" data-testid="whatsapp-card">
                <div className="contact-card-icon wa-icon"><WhatsAppIcon size={22} /></div>
                <h4 className="contact-card-title">WhatsApp</h4>
                <p className="contact-card-note">{t.contact.waNote}</p>
                <a href={WA_URL} target="_blank" rel="noopener noreferrer" className="btn-wa" data-testid="contact-whatsapp-btn">
                  <WhatsAppIcon size={16} /><span>{t.contact.waCta}</span>
                </a>
              </div>
              <div className="contact-card" data-testid="instagram-card">
                <div className="contact-card-icon ig-icon"><InstagramIcon size={22} /></div>
                <h4 className="contact-card-title">Instagram</h4>
                <p className="contact-card-note">{t.contact.igNote}</p>
                <a href={IG_URL} target="_blank" rel="noopener noreferrer" className="btn-ig" data-testid="contact-instagram-btn">
                  @{settings.instagramHandle || "aphealife"}
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="aphea-footer" data-testid="footer">
        <div className="footer-inner">
          <div className="footer-brand">
            <img src={images.logoFooter || images.logoNavbar} alt="APHEA" className="footer-logo-img" />
            <p className="footer-subtitle">Güzellik & Dönüşüm Merkezi</p>
            <p className="footer-tagline">{t.footer.tagline}</p>
            <a href={`tel:${settings.phoneNumber || "+905336333807"}`} className="footer-phone" data-testid="footer-phone">
              <svg width={14} height={14} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" style={{ display:"inline", marginRight:6 }}><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>
              {settings.phoneNumber || "+90 533 633 38 07"}
            </a>
          </div>
          <div className="footer-nav">
            <button onClick={() => scrollTo("services")} data-testid="footer-services">{t.nav.services}</button>
            <button onClick={() => scrollTo("about")} data-testid="footer-about">{t.nav.about}</button>
            <button onClick={() => scrollTo("contact")} data-testid="footer-contact">{t.nav.contact}</button>
          </div>
          <div className="footer-social">
            <a href={IG_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" aria-label="Instagram"><InstagramIcon size={22} /></a>
            <a href={FB_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-facebook" aria-label="Facebook"><FacebookIcon size={22} /></a>
            <a href={WA_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp" aria-label="WhatsApp"><WhatsAppIcon size={22} /></a>
            <a href={YT_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-youtube" aria-label="YouTube"><YouTubeIcon size={22} /></a>
            <a href={LI_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-linkedin" aria-label="LinkedIn"><LinkedInIcon size={22} /></a>
          </div>
        </div>
        <div className="footer-bottom">
          <p>
            <a href={MAPS_URL} target="_blank" rel="noopener noreferrer" className="location-link footer-location-link">
              <MapPinIcon />Antalya – Döşemealtı | Palm City Modern
            </a>
          </p>
          <div className="footer-bottom-right">
            <p>© {new Date().getFullYear()} APHEA. Tüm Hakları Saklıdır.</p>
            <a href="https://www.signaturebrand.tr" target="_blank" rel="noopener noreferrer" className="signature-brand-link" data-testid="signature-brand-link">Signature Brand</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
